import api from "./api";

export const fetchCommissionConfigurations = async () => {
    try {
        const response = await api.get(
            "/agent-commission-config/agent-commission/configurations"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent commission configurations.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent commission configurations.",
        };
    }
};

export const createCommissionConfiguration = async (payload) => {
    try {
        const response = await api.post(
            "/agent-commission-config/agent-commission/configurations",
            payload
        );

        if (
            (response.status === 200 || response.status === 201) &&
            response.data?.success
        ) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to create agent commission configuration.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create agent commission configuration.",
        };
    }
};

export const updateCommissionConfiguration = async (
    configurationId,
    payload
) => {
    try {
        const response = await api.put(
            `/agent-commission-config/agent-commission/configurations/${configurationId}`,
            payload
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to update agent commission configuration.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update agent commission configuration.",
        };
    }
};

export const deleteCommissionConfiguration = async (configurationId) => {
    try {
        const response = await api.delete(
            `/agent-commission-config/agent-commission/configurations/${configurationId}`
        );

        if (
            (response.status === 200 || response.status === 204) &&
            (response.status === 204 || response.data?.success)
        ) {
            return {
                success: true,
                data: response.data?.data,
                message:
                    response.data?.message ||
                    "Agent commission configuration deleted successfully.",
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to delete agent commission configuration.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to delete agent commission configuration.",
        };
    }
};